module.exports = __webpack_public_path__ + "e3ac211af2ceef21d20d9d028aeacc03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_2x.png
// module id = 37
// module chunks = 0 1 2 3 4